const API_META_SELECTOR = 'meta[name="google-maps-api-url"]';
const API_SCRIPT_SELECTOR = 'script[data-google-maps-api]';

let googleMapsPromise;

const isGoogleMapsReady = () => {
  return window.google && window.google.maps && window.google.maps.places;
};

const loadGoogleMaps = () => {
  if (isGoogleMapsReady()) {
    return Promise.resolve(window.google);
  }

  if (googleMapsPromise) {
    return googleMapsPromise;
  }

  googleMapsPromise = new Promise((resolve, reject) => {
    const apiMeta = document.querySelector(API_META_SELECTOR);
    const apiUrl = apiMeta && apiMeta.content;

    if (!apiUrl) {
      reject(new Error('Google Maps API URL is not configured.'));
      return;
    }

    let script = document.querySelector(API_SCRIPT_SELECTOR);

    const handleLoad = () => {
      if (isGoogleMapsReady()) {
        resolve(window.google);
      } else {
        reject(new Error('Google Maps API did not initialize.'));
      }
    };

    const handleError = () => reject(new Error('Google Maps API failed to load.'));

    if (script) {
      script.addEventListener('load', handleLoad, { once: true });
      script.addEventListener('error', handleError, { once: true });
      return;
    }

    script = document.createElement('script');
    script.src = apiUrl;
    script.async = true;
    script.dataset.googleMapsApi = 'true';
    script.addEventListener('load', handleLoad, { once: true });
    script.addEventListener('error', handleError, { once: true });
    document.head.appendChild(script);
  });

  return googleMapsPromise;
};

export default loadGoogleMaps;
